"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4489],{

/***/ 14489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ foodProgram_CustomerExamples; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 1 modules
var Trans = __webpack_require__(59251);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/customer-reasons/sumup.png
/* harmony default export */ var sumup = ({"src":"/_next/static/media/sumup.b1b2a1fd.png","height":420,"width":420,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJ1BMVEXN34TR3InR3orY4p7O2ofa5pDQ3InO24jP3YnN2oXo7snh7pbs9MKfNFVLAAAAC3RSTlMHvXX+/P27uXH6/eYt1JkAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA1SURBVHicRcpBDsAwCMRAEwhZuv3/e6uecrM0BhQhgPbebliumrGI98lM942farzuDDpH8AEu3wFUMAYNhwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/customer-reasons/results-icon.png
/* harmony default export */ var results_icon = ({"src":"/_next/static/media/results-icon.4bd3bc71.png","height":116,"width":118,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAGFBMVEWh1Fiey2Gey2GdzGKby2Key2Kdyl+ezGDYq2aHAAAACHRSTlMBTGAVIDssfLCcqWwAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAxSURBVHicJYsxEgAwCMIAQf//4542CxkIcHTflCZfZnxCplCmJAMeqrVfkUltQYbGAxJXAI24b9Z7AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/customer-reasons/situation-icon.png
/* harmony default export */ var situation_icon = ({"src":"/_next/static/media/situation-icon.5fe659b6.png","height":116,"width":118,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAFVBMVEWfzGGezGKdyV+ey2GezGKfy2JMaXH0Gr1yAAAAB3RSTlNWNRxFazsAMDy5vgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAADBJREFUeJwdxrcRwDAQBLE99/2XzJEQgaNaOKgt54hhcMgl9Auof0JDmCe5I5O03AMWuwCmdhRj2gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/customer-reasons/solution-icon.png
/* harmony default export */ var solution_icon = ({"src":"/_next/static/media/solution-icon.e3b032b4.png","height":116,"width":118,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAFVBMVEWey2Gey2GezGGdyV+ezGFMaXGezGEflJX6AAAAB3RSTlNINl4RIABxgGpz7AAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAADBJREFUeJwVybcRADAMA7Fn0v4j+1yhAEuhGePAGnIXLCC9D+I061cni2FsxiJQ9gAVjQCSB4aJCAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/static_pages/foodProgram/CustomerExample.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        "px;\n  align-items: center;\n  flex-direction: column;\n\n  ",
        " {\n    gap: ",
        "px;\n  }\n\n  ",
        " {\n    flex-direction: row;\n    gap: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  text-align: start;\n\n  gap: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









function CustomerExample(props) {
    var t = (0,useTranslation/* useTranslation */.$)("food_program").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExampleWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                width: {
                    xs: "min(70vw, 150px)",
                    md: "min(20vw, 210px)"
                },
                flexShrink: 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: "",
                    src: props.image,
                    height: 210,
                    width: 210,
                    objectFit: "cover"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SituationList, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                        component: "h3",
                        textAlign: {
                            xs: "center",
                            md: "start"
                        },
                        fontWeight: 600,
                        mb: 3,
                        fontSize: {
                            xs: 16,
                            md: 20
                        },
                        children: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Situation, {
                        src: situation_icon,
                        textBase: t("customerExamples.situationBase"),
                        text: props.situation
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Situation, {
                        src: solution_icon,
                        textBase: t("customerExamples.solutionBase"),
                        text: props.solution
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Situation, {
                        src: results_icon,
                        textBase: t("customerExamples.resultsBase"),
                        text: props.results
                    })
                ]
            })
        ]
    });
}
function Situation(param) {
    var src = param.src, textBase = param.textBase, text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
        display: "flex",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                flexGrow: 0,
                height: "59px",
                flexShrink: 0,
                mr: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: "",
                    src: src,
                    height: 59,
                    width: 59
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Typography, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Typography, {
                        component: "span",
                        fontWeight: 600,
                        children: [
                            textBase,
                            " "
                        ]
                    }),
                    text
                ]
            })
        ]
    });
}
var ExampleWrapper = styled_components_browser_esm["default"].div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(4);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(11);
});
var SituationList = styled_components_browser_esm["default"].div(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
/* harmony default export */ var foodProgram_CustomerExample = (CustomerExample);

// EXTERNAL MODULE: ./src/static_pages/foodProgram/Utils.tsx
var Utils = __webpack_require__(54397);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/static_pages/foodProgram/CustomerExamples.tsx











var sumupExample = createExample("sumup", sumup);
function createExample(keyFragment, image) {
    var base = "customerExamples";
    return {
        titleKey: "".concat(base, ".").concat(keyFragment, ".title"),
        situationKey: "".concat(base, ".").concat(keyFragment, ".situation"),
        solutionKey: "".concat(base, ".").concat(keyFragment, ".solution"),
        resultKey: "".concat(base, ".").concat(keyFragment, ".result"),
        image: image
    };
}
var CustomerExamples = function(props) {
    var theme = (0,styled_components_browser_esm.useTheme)();
    var t = (0,useTranslation/* useTranslation */.$)("food_program").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: "section",
        textAlign: "center"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                size: 860,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Utils/* FoodProgramH2 */.s, {
                    mb: {
                        xs: 5,
                        md: 9
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                        t: t,
                        i18nKey: "customerExamples.title",
                        components: {
                            "1": /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                as: "span",
                                color: theme.palette.secondary[400]
                            }),
                            "2": /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                size: 960,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                    mb: 5,
                    position: "relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(foodProgram_CustomerExample, {
                        image: sumupExample.image,
                        title: t(sumupExample.titleKey),
                        situation: t(sumupExample.situationKey),
                        solution: t(sumupExample.solutionKey),
                        results: t(sumupExample.resultKey)
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var foodProgram_CustomerExamples = (CustomerExamples);


/***/ })

}]);